import {
  Box,
  Container,
  Divider,
  Link,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Stack,
  Typography
} from '@mui/material'
import { FormsProps } from '../../types'
import { isEmpty, isNil } from 'lodash/fp'
import { CheckBox as CheckBoxIcon } from '@mui/icons-material'

export const RequestConfirm = (props: FormsProps) => {
  const { formData } = props
  const {
    lastName,
    firstName,
    lastNameKana,
    firstNameKana,
    postalCode,
    pref,
    city,
    town,
    place,
    phone,
    email,
    barthYear,
    barthMonth,
    gender,
    gas,
    kateneMailMagazine,
    tokutokuMailMagazine,
    customerNumber,
    payment,
    paymentNumber,
    contractorName,
    contractorPostalCode,
    contractorPhone,
    couponCode
  } = formData
  return (
    <Container sx={{ pt: 5 }}>
      <Box>入力内容をご確認ください。</Box>
      <Box paddingBottom={3}>
        問題がない場合は「お申し込み」ボタンを押してください。
      </Box>
      <Box component="form" sx={{ mt: 1 }}>
        <Stack spacing={3}>
          <Typography
            align="left"
            variant="h4"
            sx={{
              borderLeft: 20,
              borderBottom: 1,
              borderColor: 'orange',
              paddingLeft: 1
            }}>
            見守る方（ご契約者さま）
          </Typography>
          <Typography variant="subtitle1">
            <Typography component={'span'} color="red">
              *
            </Typography>
            <Typography component={'span'} sx={{ ml: 1 }}>
              お名前（漢字）
            </Typography>
          </Typography>
          <Typography variant="subtitle2">
            {lastName}　{firstName}
          </Typography>
          <Typography variant="subtitle1">
            <Typography component={'span'} color="red">
              *
            </Typography>
            <Typography component={'span'} sx={{ ml: 1 }}>
              お名前（かな）
            </Typography>
          </Typography>
          <Typography variant="subtitle2">
            {lastNameKana}　{firstNameKana}
          </Typography>
          <Typography variant="subtitle1">
            <Typography component={'span'} color="red">
              *
            </Typography>
            <Typography component={'span'} sx={{ ml: 1 }}>
              郵便番号（半角）
            </Typography>
          </Typography>
          <Typography variant="subtitle2">{postalCode}</Typography>
          <Typography variant="subtitle1">住所</Typography>
          <Typography variant="subtitle2">{pref}　{city} {town} {!isNil(place) ? place : ''}</Typography>
          <Typography variant="subtitle1">
            <Typography component={'span'} color="red">
              *
            </Typography>
            <Typography component={'span'} sx={{ ml: 1 }}>
              電話番号（半角）
            </Typography>
          </Typography>
          <Typography variant="subtitle2">{phone}</Typography>
          <Typography variant="subtitle1">
            <Typography component={'span'} sx={{ ml: 1 }}>
              メールアドレス
            </Typography>
          </Typography>
          <Typography variant="subtitle2">{email}</Typography>
          <Typography variant="subtitle1">
            <Typography component={'span'} color="red">
              *
            </Typography>
            <Typography component={'span'} sx={{ ml: 1 }}>
              生年月
            </Typography>
          </Typography>
          <Typography variant="subtitle2">
            {barthYear}年{barthMonth}月
          </Typography>
          <Typography variant="subtitle1">
            <Typography component={'span'} color="red">
              *
            </Typography>
            <Typography component={'span'} sx={{ ml: 1 }}>
              性別
            </Typography>
          </Typography>
          <Typography variant="subtitle2">
            {gender === 'male'
              ? '男性'
              : gender === 'female'
              ? '女性'
              : gender === 'nothing'
              ? '回答しない'
              : ''}
          </Typography>
          <Typography variant="subtitle1">
            <Typography component={'span'} color="red">
              *
            </Typography>
            <Typography component={'span'} sx={{ ml: 1 }}>
              ガスの種類
            </Typography>
          </Typography>
          <Typography variant="subtitle2">
            {gas === 'town'
              ? '都市ガス'
              : gas === 'propane'
              ? 'プロパンガス'
              : gas === 'nothing'
              ? 'ガスを使用していない'
              : ''}
          </Typography>
          <Typography variant="subtitle1">
            <Typography component={'span'} sx={{ ml: 1 }}>
              カテエネメールマガジンの設定
            </Typography>
          </Typography>
          <Typography variant="subtitle2">
            カテエネメールマガジン:{' '}
            {kateneMailMagazine ? '希望する' : '希望しない'}
          </Typography>
          <Typography variant="subtitle2">
            とくとくメールマガジン:{' '}
            {tokutokuMailMagazine ? '希望する' : '希望しない'}
          </Typography>
          <Typography
            align="left"
            variant="h4"
            sx={{
              borderLeft: 20,
              borderBottom: 1,
              borderColor: 'orange',
              paddingLeft: 1
            }}>
            見守られる方（ご家族さま）
          </Typography>
          {!isEmpty(customerNumber) ? (
            <>
              <Typography variant="subtitle1">
                <Typography component={'span'} color="red">
                  *
                </Typography>
                <Typography component={'span'} sx={{ ml: 1 }}>
                  電気契約お客さま番号
                </Typography>
              </Typography>
              <Typography variant="subtitle2">{customerNumber}</Typography>
            </>
          ) : (
            <></>
          )}
          <Typography variant="subtitle1">
            <Typography component={'span'} color="red">
              *
            </Typography>
            <Typography component={'span'} sx={{ ml: 1 }}>
              電気契約のお支払方法
            </Typography>
          </Typography>
          <Typography variant="subtitle2">
            {payment === 'credit'
              ? 'クレジットカード'
              : payment === 'transfer'
              ? '口座振替'
              : payment === 'unknown'
              ? 'その他またはわからない'
              : ''}
          </Typography>
          {!isEmpty(paymentNumber) ? (
            <>
              <Typography variant="subtitle1">
                <Typography component={'span'} color="red">
                  *
                </Typography>
                <Typography component={'span'} sx={{ ml: 1 }}>
                  {payment === 'credit'
                    ? 'カード番号（下4桁）'
                    : '口座番号（下4桁）'}
                </Typography>
              </Typography>
              <Typography variant="subtitle2">{paymentNumber}</Typography>
            </>
          ) : (
            <></>
          )}
          {!isEmpty(contractorName) ? (
            <>
              <Typography variant="subtitle1">
                <Typography component={'span'} color="red">
                  *
                </Typography>
                <Typography component={'span'} sx={{ ml: 1 }}>
                  電気契約名義（漢字・全角）
                </Typography>
              </Typography>
              <Typography variant="subtitle2">{contractorName}</Typography>
            </>
          ) : (
            <></>
          )}
          {!isEmpty(contractorPostalCode) ? (
            <>
              <Typography variant="subtitle1">
                <Typography component={'span'} color="red">
                  *
                </Typography>
                <Typography component={'span'} sx={{ ml: 1 }}>
                  郵便番号（半角）
                </Typography>
              </Typography>
              <Typography variant="subtitle2">
                {contractorPostalCode}
              </Typography>
            </>
          ) : (
            <></>
          )}
          {!isEmpty(contractorPhone) ? (
            <>
              <Typography variant="subtitle1">
                <Typography component={'span'} color="red">
                  *
                </Typography>
                <Typography component={'span'} sx={{ ml: 1 }}>
                  電話番号（半角）
                </Typography>
              </Typography>
              <Typography variant="subtitle2">{contractorPhone}</Typography>
            </>
          ) : (
            <></>
          )}
          <Typography
            align="left"
            variant="h4"
            sx={{
              borderLeft: 20,
              borderBottom: 1,
              borderColor: 'orange',
              paddingLeft: 1,
              mt: 3
            }}>
            サービス利用規約への同意
          </Typography>
          <List>
            <ListItem>
              <ListItemIcon>
                <CheckBoxIcon />
              </ListItemIcon>
              <ListItemText>
                テラシテサービス利用規約に同意します。
              </ListItemText>
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <CheckBoxIcon />
              </ListItemIcon>
              <ListItemText>
                私は、見守られる方（ご家族さま）にテラシテの内容を説明した上で、見守られる方（ご家族さま）の個人情報を取得すること、見守られる方（ご家族さま）の電力消費データが私に開示されることについて、同意を得ていることを誓約します。
              </ListItemText>
            </ListItem>
          </List>
          <Divider />
          {!isEmpty(couponCode) ? (
            <>
              <Typography variant="subtitle1">
                <Typography component={'span'} sx={{ ml: 1 }}>
                  紹介コード
                </Typography>
              </Typography>
              <Typography variant="subtitle2">{couponCode}</Typography>
            </>
          ) : (
            <></>
          )}
          <Typography
            align="left"
            variant="h4"
            sx={{
              borderLeft: 20,
              borderBottom: 1,
              borderColor: 'orange',
              paddingLeft: 1,
              mt: 3
            }}>
            クレジットカード
          </Typography>
          <Typography variant="subtitle2">登録済み</Typography>
          <Typography
            align="left"
            variant="h4"
            sx={{
              borderLeft: 20,
              borderBottom: 1,
              borderColor: 'orange',
              paddingLeft: 1,
              mt: 3
            }}>
            ご契約内容
          </Typography>
          <List>
            <ListItem>
              <ListItemIcon>
                <span
                  style={{
                    display: 'inline-block',
                    width: '6px',
                    height: '6px',
                    backgroundColor: 'black',
                    borderRadius: '50%',
                    marginTop: '6px'
                  }}></span>
              </ListItemIcon>
              <ListItemText>
                くらしの近況お届けサービス「テラシテ」の具体的な内容については
                <Link href="https://www.terashite.jp/" target="_blank">
                  {' '}
                  こちら{' '}
                </Link>
                をご参照ください。
              </ListItemText>
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <span
                  style={{
                    display: 'inline-block',
                    width: '6px',
                    height: '6px',
                    backgroundColor: 'black',
                    borderRadius: '50%',
                    marginTop: '6px'
                  }}></span>
              </ListItemIcon>
              <ListItemText>
                本サービスは1か月単位で、自動更新されます。
              </ListItemText>
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <span
                  style={{
                    display: 'inline-block',
                    width: '6px',
                    height: '6px',
                    backgroundColor: 'black',
                    borderRadius: '50%',
                    marginTop: '6px'
                  }}></span>
              </ListItemIcon>
              <ListItemText>
                毎月1日に当月分の月額550円（税込）をお客さまがご登録されたクレジットカードに請求します。年額では、1年分のお支払総額6,600円（税込）となります。
              </ListItemText>
            </ListItem>

            <ListItem>
              <ListItemIcon>
                <span
                  style={{
                    display: 'inline-block',
                    width: '6px',
                    height: '6px',
                    backgroundColor: 'black',
                    borderRadius: '50%',
                    marginTop: '6px'
                  }}></span>
              </ListItemIcon>
              <ListItemText>
                新規にお申込みいただいた場合、原則としてサービスの提供を開始する月の利用料金は無料とし、本サービスを開始した月の翌月の利用料金からお支払いただきます。
              </ListItemText>
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <span
                  style={{
                    display: 'inline-block',
                    width: '6px',
                    height: '6px',
                    backgroundColor: 'black',
                    borderRadius: '50%',
                    marginTop: '6px'
                  }}></span>
              </ListItemIcon>
              <ListItemText>
                当社は、お申込み内容を確認のうえメールにより利用の承諾をいたします。お客さまは、当社が承諾した日からテラシテのご利用が可能となります。
              </ListItemText>
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <span
                  style={{
                    display: 'inline-block',
                    width: '6px',
                    height: '6px',
                    backgroundColor: 'black',
                    borderRadius: '50%',
                    marginTop: '6px'
                  }}></span>
              </ListItemIcon>
              <ListItemText>
                ご解約については、お客さまポータル画面から毎月15日までに当社へ通知することにより当月末日をもって解約ができます。毎月16日以降に当社へ通知した場合には翌月末日をもって解約となります。詳しくは、こちらの
                <Link
                  href="https://terashite.zendesk.com/hc/ja/articles/4881035886361-%E3%83%86%E3%83%A9%E3%82%B7%E3%83%86%E3%81%AE%E8%A7%A3%E7%B4%84%E6%96%B9%E6%B3%95%E3%82%92%E6%95%99%E3%81%88%E3%81%A6%E3%81%8F%E3%81%A0%E3%81%95%E3%81%84"
                  target="_blank">
                  {' '}
                  FAQ{' '}
                </Link>
                をご参照ください。
              </ListItemText>
            </ListItem>
          </List>
          <Divider sx={{ mt: 5, mb: 5 }} />
          <Typography component={'span'} sx={{ ml: 1 }}>
            まだお申し込みは完了していません。
            <br />
            上記ご確認の上、「お申し込み」を押してください。
          </Typography>
        </Stack>
      </Box>
    </Container>
  )
}
